module.exports = __webpack_public_path__ + "static/media/skill.f063c93d.svg";